var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":"Message","hide-footer":"","size":"sm","centered":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }